export const printFile = (blob: Blob) => {
  const fileURL = (window.URL ? URL : webkitURL).createObjectURL(blob);

  const popup = window.open(
    fileURL,
    '_blank',
    'top=150,left=200,width=750,height=480,titlebar=no,location=no,menubar=no,status=no,toolbar=no,resizable=no',
  );
  if (popup) {
    popup.focus();
    popup.print();
  }
};
